export default {
    paymintApiUrl: 'https://ep-shared-global-afd-c0g2csedfkd0fcf7.a01.azurefd.net',
    clientId: '074d377a-c0e5-40cc-a54a-7fae7bdeeef5',
    authority:'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    LogLevel: 5, // Default to Warning level
    sampleRate: 0
};